export const COOKIE_LIFETIME = 1 // life time in number of days
export const COOKIE_USER_ID = 'app_iamp_user'

export enum ModuleState {
  ReadyToUpload = 'ReadyToUpload',
  AnalyzingFile = 'Analyzing',
  Uploading = 'Uploading',
  PreparingProcess = 'PreparingProcess',
  Processing = 'Processing',
  Complete = 'Complete',
  Error = 'Error',
  RequirementError = 'RequirementError',
  CreditError = 'CreditError',
}

export const ModuleErrorTitle = {
  Default: 'An error occured',
  InsufficientCredit: 'Insufficient credits',
  FileRequirement: 'Wrong file format',
}


export const ModuleErrorMessage = {
  Default: "Try again or contact our support",
  Upgrade: 'Upgrade your plan to process more tracks!',
}

export const ModuleErrorButtonText = {
  Default: "Try again",
  Upgrade: 'Upgrade',
  Back: 'Back',
}


/**
 * Return true if the given state means the current processing is completed.
 *
 * @param state The state to evaluate
 */
export function isProcessingCompleted(state: ModuleState) {
  switch (state) {
    case ModuleState.Complete:
    case ModuleState.Error:
    case ModuleState.RequirementError:
    case ModuleState.CreditError:
      return true

    default:
      return false
  }
}

/**
 * Return true if the given state means the component is able to receive
 * a file to upload.
 *
 * @param state The state to evaluate
 */
export function isReadyToUpload(state: ModuleState) {
  switch (state) {
    case ModuleState.ReadyToUpload:
    case ModuleState.Complete:
    case ModuleState.Error:
    case ModuleState.RequirementError:
    case ModuleState.CreditError:
      return true

    default:
      return false
  }
}

/**
 * Return true if the given state represents an error.
 *
 * @param state The state to evaluate
 */
export function isError(state: ModuleState) {
  switch (state) {
    case ModuleState.Error:
    case ModuleState.RequirementError:
    case ModuleState.CreditError:
      return true

    default:
      return false
  }
}
